import { z } from 'zod';

import { TranslationFnMap } from '~shared/i18n';

type LoginCipErrorsKey =
  | 'CIP_REQUIRED'
  | 'IDENTIFIER_REQUIRED'
  | 'PASSWORD_REQUIRED';

type LoginCipFormErrors = TranslationFnMap<LoginCipErrorsKey>;

const loginCipSchema = z.object({
  cip: z.string().min(1, { error: 'CIP_REQUIRED' }),
  email: z.string().min(1, { error: 'IDENTIFIER_REQUIRED' }),
  password: z.string().min(1, { error: 'PASSWORD_REQUIRED' }),
});

type LoginCipFormData = z.infer<typeof loginCipSchema>;

export { type LoginCipFormData, type LoginCipFormErrors, loginCipSchema };
